export default function RouteSkeleton() {
  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'var(--sg-bg, #fafafa)',
      }}
      aria-label="Loading"
      role="status"
    >
      <div
        style={{
          width: 40,
          height: 40,
          borderRadius: '50%',
          border: '4px solid rgba(79, 70, 229, 0.12)',
          borderTopColor: '#4f46e5',
          animation: 'sg-spin 0.8s linear infinite',
        }}
      />
      <style>{`@keyframes sg-spin { to { transform: rotate(360deg); } }`}</style>
    </div>
  )
}
